<script setup>
// компонент загрузки файла с ЭЦП
import AppUploadDocument from "@/components/Forms/AppUploadDocument";
import {ref, onMounted, computed} from 'vue'
import {useStore} from "vuex";
import axios from "axios";

const isLoading = ref(false)
const history = ref([])
const store = useStore()
//----------------------------------------------------------------------
// eslint-disable-next-line no-undef,no-unused-vars
const props = defineProps({
  title:{
    type: String,
    required: true,
  },
  section:{
    type: String,
    required: true,
  },
})
//----------------------------------------------------------------------
const isModalUploadVisible = ref(false)

onMounted( ()=>{
  init()
})

const init = async () => {
  isLoading.value = true
  store.commit('menuModule/initMenu')

  const url = process.env.VUE_APP_API + "docs-history.php"
  await axios
      .get(`${url}?token=${token.value}&section=${props.section}&id=${user.value.id}`)
      .then(response => (history.value = response.data))
      .catch(error => alert(error));

  if (history.value.length === 0) {
    setTimeout(() => isLoading.value = false, 1000);
  } else {
    isLoading.value = false
  }
}

// сообщение отправлено
const create = async () => {
  isModalUploadVisible.value = false
  await init()
}

const cardStyle = (status) => {

  if (+status === 1){
    return 'card-primary'
  } else if(+status === 2){
    return 'card-success'
  } else if(+status === 3){
    return 'card-danger'
  }

}

//----------------------------------------------------------------------

const token = computed( () => {return store.getters['authModule/token']})
const user = computed( () => {return store.getters['authModule/user']})

//----------------------------------------------------------------------

/*
// структура загружаемых файлов
const docs = ref([
  { type: 'ИП', name: 'Справка о доходах', section: 1 },
  { type: 'ИП', name: 'Другой документ', section: 2 },
])

const getDocumentName = (section) => {
  // section привести к NUMBER и найти index в массиве docs
  const index = docs.value.findIndex(e => e.section === +section);
  return docs.value[index]['name']
}
*/

</script>

<template>

    <section class="content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <h3>{{ props.title }}</h3>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">

        <div class="row">
          <div class="col-12">
            <v-icon-link
                title="Загрузить документ"
                icon="mdi:file-document-plus-outline"
                @click="isModalUploadVisible=true"
            ></v-icon-link>
            <div v-if="history.length">

              <div
                  :class="['mt-2', 'card', 'card-outline', cardStyle(item.status)]"
                  v-for="item in history" :key="item.Key"
              >

                <div class="card-header">

                  <div v-if="Number(item.status) === 1">
                    <v-icon
                        class="status-icon--blue"
                        icon="mdi:clock-outline"
                    ></v-icon>
                    Документ на рассмотрении
                  </div>
                  <div v-else-if="Number(item.status) === 2">
                    <v-icon
                        class="status-icon--green"
                        icon="mdi:check-circle-outline"
                    ></v-icon>
                    Документ принят
                  </div>
                  <div v-else-if="Number(item.status) === 3">
                    <v-icon
                        class="status-icon--red"
                        icon="mdi:alert-circle-outline"
                    ></v-icon>
                    Документ отклонен
                  </div>

                </div>
                <div class="card-body">
                  <a
                      :href="'https://lk.gorcenter.spb.ru/api/download?t='+token+'&c='+item.document_code+'&u='+user.id"
                      target="_blank"
                  >Скачать документ</a>

                  <div class="mt-2">
                    <a
                        download
                        :href="'https://lk.gorcenter.spb.ru/api/download?t='+token+'&c='+item.document_code+'&u='+user.id+'&sign='+Date.now()"
                    >Скачать подпись</a>
                  </div>

                  <div v-if="item.comment" class="mt-4 pt-2 border-top">
                    {{ item.comment }}
                  </div>

                </div>
                <div class="card-footer">
                  Загружен {{ item.upload_date_time }}
                </div>
              </div>
            </div>
                  <div v-else class="d-flex justify-content-center">
                    <div
                        v-if="isLoading"
                        class="spinner-border text-primary m-4" role="status"
                    ></div>
                    <div v-else class="p-4">Нет загруженных документов</div>
                  </div>
                </div>

              </div>
            </div>
    </section>

    <teleport to="body">

      <AppUploadDocument
          v-if = "isModalUploadVisible"
          :title="props.title"
          :section="props.section"
          @close = "isModalUploadVisible = false"
          @create = "create"
      ></AppUploadDocument>

    </teleport>
</template>

<style scoped></style>